import { Fragment, useCallback, useEffect, useState } from "react";
import {
  fetchFreshFoodSummary,
  postFreshFoodIngestDryRun,
  postFreshFoodIngestRun,
} from "../../../../api/foodApi";

const FoodFreshFoodSection = ({ canManage = false }) => {
  const [summary, setSummary] = useState(null);
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const load = useCallback(async () => {
    try {
      setSummary(await fetchFreshFoodSummary());
      setErrorMessage("");
    } catch (error) {
      setErrorMessage(error.message || "Unable to load fresh food summary.");
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const runDryRun = async () => {
    if (!canManage || busy) return;
    try {
      setBusy(true);
      setResult(await postFreshFoodIngestDryRun({ sourceKey: "OSM_FRESH_FOOD_POIS", useMock: true }));
      await load();
    } catch (error) {
      setErrorMessage(error.message || "Dry run failed.");
    } finally {
      setBusy(false);
    }
  };

  const runIngest = async () => {
    if (!canManage || busy) return;
    if (!window.confirm("Run fresh food POI ingest using configured provider/mock?")) return;
    try {
      setBusy(true);
      setResult(
        await postFreshFoodIngestRun({
          sourceKey: "OSM_FRESH_FOOD_POIS",
          confirm: true,
          useMock: true,
        })
      );
      await load();
    } catch (error) {
      setErrorMessage(error.message || "Ingest failed.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="panel-card food-fresh-food-section">
      <h2>Fresh food POIs</h2>
      <p className="muted">
        Separate from supermarket OSM ingest. Disabled source by default; dry run first.
      </p>
      {errorMessage ? <p className="form-error">{errorMessage}</p> : null}
      {summary?.coverage ? (
        <div className="food-fresh-food-section__kpi-row">
          <div>
            <span className="muted">Enabled</span>
            <strong>{summary.enabled ? "yes" : "no"}</strong>
          </div>
          <div>
            <span className="muted">Total points</span>
            <strong>{summary.coverage.totalFreshFoodPoints ?? 0}</strong>
          </div>
          <div>
            <span className="muted">Needs review</span>
            <strong>{summary.coverage.needsReviewCount ?? 0}</strong>
          </div>
        </div>
      ) : null}
      {canManage ? (
        <div className="food-fresh-food-section__actions">
          <button type="button" className="btn btn--secondary" disabled={busy} onClick={runDryRun}>
            Fresh POI dry run
          </button>
          <button type="button" className="btn btn--primary" disabled={busy} onClick={runIngest}>
            Ingest fresh POIs (mock)
          </button>
        </div>
      ) : (
        <p className="muted">Admin actions require source manage permission.</p>
      )}
      {result ? (
        <pre className="food-fresh-food-section__result">{JSON.stringify(result, null, 2)}</pre>
      ) : null}
    </section>
  );
};

export default FoodFreshFoodSection;
